import React, { ReactElement, ReactNode, useMemo } from 'react'
import { EMPTY_STRING } from '../../../../NonReact/constants/Common'

export type LabelProps = {
    children: ReactNode
    customClass?: string
    htmlFor?: string
    title?: string
    onClick?: (e?: React.MouseEvent) => void
}

const Label: React.FC<LabelProps> = ({ children, customClass, htmlFor, title, onClick }: LabelProps): ReactElement => {
    const className: string = useMemo((): string => `label ${customClass || EMPTY_STRING}`, [customClass])

    return (
        <label className={className} htmlFor={htmlFor} title={title} onClick={onClick}>
            {children}
        </label>
    )
}

export default Label
